import {useLayoutEffect,useState,type SVGProps} from 'react';
import type {Asset} from '../shared/types';
import {ArtworkImageCache,ArtworkImageError} from './artworkImageCache';

/** The same SVG composition with a leased, short-lived presentation URL. */
export default function ArtworkImage({asset,cache,...props}:Omit<SVGProps<SVGImageElement>,'href'>&{asset:Asset;cache:ArtworkImageCache}){
 const [retry,setRetry]=useState(0),[loaded,setLoaded]=useState<{cache:ArtworkImageCache;source:string;href:string|undefined}|null>(null);
 const retained=!asset.id.startsWith('builtin-'),allowed=cache.canRead(asset.url);
 useLayoutEffect(()=>{
  if(!retained||!allowed)return;
  let active=true,timer:ReturnType<typeof setTimeout>|undefined;
  const lease=cache.acquire(asset.url,asset.width,asset.height);
  setLoaded({cache,source:asset.url,href:lease.href});
  void lease.promise.then(href=>{if(active)setLoaded({cache,source:asset.url,href});}).catch(error=>{
   if(active&&retry===0&&(error instanceof ArtworkImageError?error.retryable:error instanceof TypeError))timer=setTimeout(()=>setRetry(1),1000);
  });
  return()=>{active=false;if(timer)clearTimeout(timer);lease.release();};
 },[cache,asset.url,asset.width,asset.height,retained,allowed,retry]);
 const href=!allowed?undefined:!retained?asset.url:loaded?.cache===cache&&loaded.source===asset.url?loaded.href:cache.peek(asset.url);
 return <image {...props} href={href} onError={event=>{props.onError?.(event);if(retained&&allowed&&href){cache.forget(asset.url);if(retry===0)setRetry(1);}}}/>;
}
